import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Header() {
  const { t, i18n } = useTranslation("");

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };
  // State to manage visibility of each dropdown using a Map
  const [dropdowns, setDropdowns] = useState(new Map());
  const [isClassAdded, setIsClassAdded] = useState(false);

  const [isSearchOpen, setIsSearchOpen] = useState(false);

  useEffect(() => {
    const header = document.getElementById("page-header");

    const handleScroll = () => {
      if (!isSearchOpen) {
        if (window.scrollY > 50) {
          header.classList.add("scrolled");
        } else {
          header.classList.remove("scrolled");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup on unmount
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsClassAdded(!isClassAdded);
  };

  // State to manage visibility of each dropdown using a Map

  // Toggle the visibility of a specific dropdown by index
  const toggleDropdown = (index) => {
    // Create a copy of the current state to avoid direct mutation
    const newDropdowns = new Map(dropdowns);

    // Toggle the state for the clicked dropdown
    newDropdowns.set(index, !newDropdowns.get(index));

    // Set the updated state
    setDropdowns(newDropdowns);
  };

  const data = [
    { id: 1, name: "Home", category: "", link: "/" },
    { id: 2, name: "About", category: "", link: "/about" },
    { id: 3, name: "Our Offerings", category: "", link: "/our-offerings" },
    { id: 4, name: "Career", category: "", link: "/career" },
    { id: 5, name: "Platform", category: "", link: "/platform" },
    { id: 6, name: "Clients", category: "", link: "/clients" },
    { id: 7, name: "Leadership", category: "", link: "/leadership" },
    { id: 8, name: "Resources", category: "", link: "/insights-resources" },
    { id: 9, name: "Contact", category: "", link: "/contact-us" },
    { id: 10, name: "Insights", category: "", link: "/insights" },

    {
      id: 11,
      name: "Startup Idea Validator",
      category: "",
      link: "/startup-idea-validator-tools",
    },
    {
      id: 12,
      name: "Business Model Generator",
      category: "",
      link: "/business-model-generator",
    },

    { id: 13, name: "FDI Institute", category: "", link: "/fdi-institute" },
    { id: 14, name: "FDI CRM", category: "", link: "/fdi-crm" },
    {
      id: 15,
      name: "Trade Intelligence Platform",
      category: "",
      link: "/trade-intelligence-platform",
    },
    {
      id: 16,
      name: "FDI Intelligence Platform",
      category: "",
      link: "/fdi-intelligence-plateform",
    },

    { id: 17, name: "Elevate by IM", category: "", link: "/elevate-by-im" },
    { id: 18, name: "Alpha", category: "", link: "/alpha" },
    { id: 19, name: "Beta", category: "", link: "/beta" },
    { id: 20, name: "Gamma", category: "", link: "/gamma" },
    { id: 21, name: "Sigma", category: "", link: "/sigma" },

    { id: 22, name: "Signup", category: "", link: "/signup" },
    { id: 23, name: "Login", category: "", link: "/login" },
    { id: 24, name: "Thank You", category: "", link: "/thank-you" },
    { id: 25, name: "Terms of Use", category: "", link: "/term-of-use" },
    { id: 26, name: "Privacy Policy", category: "", link: "/privacy-policy" },

    { id: 27, name: "Podcast", category: "", link: "/podcast" },
    { id: 28, name: "Webinar", category: "", link: "/webinar" },
    { id: 29, name: "Blog", category: "", link: "/blog" },
    { id: 30, name: "Help", category: "", link: "/help" },
    { id: 31, name: "Chatbot", category: "", link: "/chatbot" },

    {
      id: 32,
      name: "Shakti Sangam 2025",
      category: "",
      link: "/shaktisangam2025",
    },
    { id: 33, name: "Registrations", category: "", link: "/registrations" },
    { id: 34, name: "User Logs", category: "", link: "/logs" },

    {
      id: 35,
      name: "Startup Consulting",
      category: "",
      link: "/startup-consulting",
    },
    {
      id: 36,
      name: "Startup Investment",
      category: "",
      link: "/startup-investment",
    },
    {
      id: 37,
      name: "Startup Advisory",
      category: "",
      link: "/startup-advisory",
    },
    {
      id: 38,
      name: "Market Entry Assistance",
      category: "",
      link: "/startup-market-entry",
    },
    {
      id: 39,
      name: "Future of Startups",
      category: "",
      link: "/startup-future-of-startup",
    },
    {
      id: 40,
      name: "Curated Sector Cohorts",
      category: "",
      link: "/startup-curated-sector",
    },
  ];

  const [query, setQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  const handleSearch = (event) => {
    console.log("searching", event.target);
    const value = event.target.value;
    setQuery(value);

    if (value.trim() !== "") {
      const results = data.filter((item) =>
        item.name.toLowerCase().includes(value.toLowerCase()),
      );
      setFilteredData(results);
    } else {
      setFilteredData([]);
    }
  };

  return (
    <>
      {" "}
      <header class="page-header header-basic" id="page-header">
        <div class="header-search-box">
          <div class="close-search"></div>
          <form
            class="nav-search search-form"
            role="search"
            method="get"
            action="#"
          >
            <div class="search-wrapper">
              <label class="search-lbl">Search for:</label>
              <input
                class="search-input"
                type="search"
                placeholder="Search..."
                name="searchInput"
                autofocus="autofocus"
                value={query}
                onChange={handleSearch}
              />
              <button class="search-btn" type="submit">
                <i class="bi bi-search icon"></i>
              </button>

              {query && (
                <ul style={{ listStyleType: "none", padding: 0 }}>
                  {filteredData.length > 0 ? (
                    filteredData.map((item) => (
                      <p>
                        <Link to={item.link} key={item.id}>
                          {item.name}
                        </Link>
                      </p>
                    ))
                  ) : (
                    <li>No results found</li>
                  )}
                </ul>
              )}
            </div>
          </form>
        </div>
        <div class="container">
          <nav class="menu-navbar">
            <div class="header-logo">
              <Link class="logo-link" to="/">
                <img
                  class="logo-img light-logo"
                  loading="lazy"
                  src="./assets/assets/images/logo/logo-light.png"
                  alt="logo"
                  style={{ width: "85px" }}
                />
              </Link>
            </div>

            <div
              className={
                isClassAdded ? "links menu-wrapper show" : "links menu-wrapper"
              }
            >
              <ul class="list-js links-list">
                <li class="menu-item">
                  <Link class="menu-link  " to="/About">
                    {t("menu.menu1")}
                  </Link>
                </li>
                <li class="menu-item has-sub-menu">
                  <Link
                    class="menu-link"
                    to="startup-consulting"
                    onClick={() => toggleDropdown(0)}
                  >
                    {t("menu.menu2.services")}
                    {/* <i class="fas fa-plus  plus-icon"></i> */}
                  </Link>
                  <ul
                    className={`sub-menu ${
                      dropdowns.get(0) ? "d-block" : "d-block"
                    }`}
                  >
                    <li class="menu-item sub-menu-item">
                      <Link
                        class="menu-link sub-menu-link"
                        to={"/startup-consulting"}
                      >
                        {t("menu.menu2.sub1")}
                      </Link>
                    </li>
                    <li class="menu-item sub-menu-item">
                      <Link
                        class="menu-link sub-menu-link"
                        to={"/startup-advisory"}
                      >
                        {t("menu.menu2.sub2")}
                      </Link>
                    </li>
                    <li class="menu-item sub-menu-item">
                      <Link
                        class="menu-link sub-menu-link"
                        to={"/startup-investment"}
                      >
                        {t("menu.menu2.sub3")}
                      </Link>
                    </li>
                    {/* <li class="menu-item sub-menu-item">
                      <Link
                        class="menu-link sub-menu-link"
                        to={"/elevate-by-im"}
                      >
                        {t("menu.menu2.sub4")}
                      </Link>
                    </li> */}
                  </ul>
                </li>

                {/* <li class="menu-item has-sub-menu">
                  <Link
                    class="menu-link"
                    to="#0"
                    onClick={() => toggleDropdown(1)}
                  >
                    {t("menu.menu3.fdi")}
                    <i class="fas fa-plus  plus-icon"> </i>
                  </Link>
                  <ul
                    className={`sub-menu ${
                      dropdowns.get(1) ? "d-block" : "d-block"
                    }`}
                  >
                    <li class="menu-item sub-menu-item">
                      <Link class="menu-link sub-menu-link" to="fdi-institute">
                        {t("menu.menu3.sub1")}
                      </Link>
                    </li>
                    <li class="menu-item sub-menu-item">
                      <Link class="menu-link sub-menu-link" to="fdi-crm">
                        {t("menu.menu3.sub2")}
                      </Link>
                    </li>
                    <li class="menu-item sub-menu-item">
                      <Link
                        class="menu-link sub-menu-link"
                        to="/trade-intelligence-platform"
                      >
                        {t("menu.menu3.sub3")}
                      </Link>
                    </li>
                    <li class="menu-item sub-menu-item">
                      <Link
                        class="menu-link sub-menu-link"
                        to="fdi-intelligence-plateform"
                      >
                        {t("menu.menu3.sub4")}
                      </Link>
                    </li>
                  </ul>
                </li> */}

                {/* <li class="menu-item">
                  <Link class="menu-link  " to="/Career">
                    {t("menu.menu4")}
                  </Link>
                </li> */}
                <li class="menu-item has-sub-menu">
                  <Link
                    class="menu-link"
                    to="/platform"
                    onClick={() => toggleDropdown(0)}
                  >
                    Platforms
                    {/* <i class="fas fa-plus  plus-icon"></i> */}
                  </Link>
                  <ul
                    className={`sub-menu ${
                      dropdowns.get(0) ? "d-block" : "d-block"
                    }`}
                  >
                    <li class="menu-item sub-menu-item">
                      <Link
                        class="menu-link sub-menu-link"
                        to="/platform?tab=imtrade"
                        state={{ tab: "imtrade" }}
                      >
                        IMTrade
                      </Link>
                    </li>
                    <li class="menu-item sub-menu-item">
                      <Link
                        class="menu-link sub-menu-link"
                        to="/platform?tab=imfdi"
                        state={{ tab: "imfdi" }}
                      >
                        IMFDI
                      </Link>
                    </li>
                    <li class="menu-item sub-menu-item">
                      <Link
                        class="menu-link sub-menu-link"
                        to="/platform?tab=imunicorn"
                        state={{ tab: "imunicorn" }}
                      >
                        IMUnicorn
                      </Link>
                    </li>
                    {/* <li class="menu-item sub-menu-item">
                      <Link
                        class="menu-link sub-menu-link"
                        to={"/elevate-by-im"}
                      >
                        {t("menu.menu2.sub4")}
                      </Link>
                    </li> */}
                  </ul>
                </li>
                {/* <li class="menu-item">
                  <Link class="menu-link  " to="plateform">
                    {t("menu.menu5")}
                    Platforms
                  </Link>
                </li> */}

                <li className="menu-item">
                  <Link className="menu-link" to="/leadership">
                    Leadership
                  </Link>
                </li>

                <li className="menu-item">
                  <Link className="menu-link" to="/insights-resources">
                    Insights
                  </Link>
                </li>

                <li class="menu-item">
                  <Link class="menu-link  " to="/elevate-by-im">
                    {t("menu.menu6")}
                  </Link>
                </li>

                <li className="menu-item">
                  <Link className="menu-link" to="/impact">
                    Impact++
                  </Link>
                </li>
               

                {/* <li className="menu-item">
                  <Link className="menu-link" to="/contact-us">
                    Contacts
                  </Link>
                </li> */}
              </ul>
            </div>

            <div class="controls-box">
              <div class="control menu-toggler" onClick={toggleMenu}>
                <span></span>
                <span></span>
                <span></span>
              </div>

              <div class="control header-search-btn">
                <i class="fa fa-search"></i>
              </div>
              <div class="control">
                <Link to="/login">
                  <i class="fa fa-user" title="MY IM"></i>
                </Link>
              </div>
              <div class="dropdown">
                {/* <button
                  type="button"
                  class="cta-btn btn-solid p-1 dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  <i class="fa fa-globe"></i>
                </button> */}
                {/* <ul class="dropdown-menu">
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      onClick={() => changeLanguage("hi")}
                    >
                      <span class="flag-icon flag-icon-in"></span> &nbsp; India
                    </a>
                  </li>
                  <li onClick={() => changeLanguage("jr")}>
                    <a class="dropdown-item" href="#">
                      <span class="flag-icon flag-icon-gr"></span> &nbsp;
                      Germany
                    </a>
                  </li>
                  <li onClick={() => changeLanguage("th")}>
                    <a class="dropdown-item" href="#">
                      <span class="flag-icon flag-icon-th"></span> &nbsp;
                      Thailand
                    </a>
                  </li>
                  <li onClick={() => changeLanguage("ind")}>
                    <a class="dropdown-item" href="#">
                      <span class="flag-icon flag-icon-id"></span> &nbsp;
                      Indonesia
                    </a>
                  </li>
                  <li onClick={() => changeLanguage("en")}>
                    <a class="dropdown-item" href="#">
                      <span class="flag-icon flag-icon-us"></span> &nbsp; USA
                    </a>
                  </li>
                </ul> */}
              </div>
            </div>
          </nav>
        </div>
        <style>{`
        .header-search-box {
            position: fixed;
            inset: 0;
            z-index: 10000;
            background: rgba(10, 15, 43, 0.96);
          }


          .page-header {
            position: fixed;
            width: 100%;
            top: 0;
            z-index: 999;
            background: transparent;
            transition: all 0.3s ease-in-out;
          }
          .page-header.scrolled {
            background: rgba(10, 15, 43, 0.95);
            backdrop-filter: blur(10px);
            box-shadow: 0 6px 20px rgba(0,0,0,0.3);
          }
          .light-logo {
            display: block;
          }
          .dark-logo {
            display: none;
          }
          .page-header.scrolled .light-logo {
            display: none;
          }
          .page-header.scrolled .dark-logo {
            display: block;
          }
            /* Hide search icon when page is scrolled */
          .page-header.scrolled .close-search {
            display: none;
          }
            

        `}</style>
      </header>
    </>
  );
}
